import 'bootstrap-icons/font/bootstrap-icons.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import MyNavbar from './components/navbar';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import Footer from './components/footer';
import Bio from './pages/bio';
import EditorialesPage from './pages/editoriales';
import ScrollToAnchor from './components/ScrollToAnchor';

function App() {
  return (
  <Router>
      <ScrollToAnchor /> 
      <MyNavbar/>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/bio" element={<Bio/>} />
        <Route path="/editoriales" element={<EditorialesPage/>} />
        <Route path="/editoriales/:id?" element={<EditorialesPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
